import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { GridProps } from './type';

const Grid = (props: GridProps): JSX.Element => {
  const {
    container,
    row,
    col = true,
    children,
    xs,
    sm,
    md,
    lg,
    xl,
    ...other
  } = props;

  const create = (): JSX.Element => {
    if (container) {
      return <Container {...other}>{children}</Container>;
    }
    if (row) {
      return <Row {...other}>{children}</Row>;
    }
    if (col) {
      return (
        <Col
          {...other}
          style={{ padding: 0, ...other.style }}
          xs={xs}
          sm={sm}
          md={md}
          lg={lg}
          xl={xl}
        >
          {children}
        </Col>
      );
    }
    return <Container>{children}</Container>;
  };

  return create();
};
export default Grid;
